// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-plus[data-v-7d8b52c2]{margin-right:5px}.demo .el-switch__label[data-v-7d8b52c2]{position:absolute;display:none;color:#fff}.demo .el-switch__label--right[data-v-7d8b52c2]{z-index:1}.demo .el-switch__label--left[data-v-7d8b52c2]{z-index:1;left:19px}.demo .el-switch__label.is-active[data-v-7d8b52c2]{display:block}.demo.el-switch .el-switch__core[data-v-7d8b52c2],.el-switch .el-switch__label[data-v-7d8b52c2]{width:60px !important}", ""]);
// Exports
module.exports = exports;
